/**
 * Custom Delete Confirmation Modal
 * Provides a styled confirmation dialog for delete operations
 */
export default function DeleteConfirmationModal({ isOpen, onConfirm, onCancel, title, message, itemName }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      onClick={onCancel}
    >
      <div
        className="rounded-lg shadow-xl max-w-md w-full mx-4 border"
        style={{
          backgroundColor: 'var(--color-bg-elevated)',
          borderColor: 'var(--color-border-default)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-6 border-b" style={{ borderColor: 'var(--color-border-default)' }}>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-500/20 rounded-lg">
              <svg className="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold" style={{ color: 'var(--color-text-primary)' }}>
                {title || 'Confirm Deletion'}
              </h3>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
            {message || `Are you sure you want to delete ${itemName}? This action cannot be undone.`}
          </p>
          {itemName && (
            <div className="mt-4 p-3 rounded-lg border" style={{
              backgroundColor: 'var(--color-bg-tertiary)',
              borderColor: 'var(--color-border-default)'
            }}>
              <p className="text-sm font-mono" style={{ color: 'var(--color-text-primary)' }}>
                {itemName}
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t flex gap-3 justify-end" style={{ borderColor: 'var(--color-border-default)' }}>
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg border font-medium transition-all duration-200"
            style={{
              backgroundColor: 'var(--color-bg-secondary)',
              borderColor: 'var(--color-border-default)',
              color: 'var(--color-text-primary)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-bg-tertiary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-bg-secondary)';
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg font-medium transition-all duration-200"
            style={{ color: 'var(--color-text-on-accent)' }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
